export default "__VITE_ASSET__CxhPnfd2__"